import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { UserDeleteRestoreMode, UserDeleteRestoreState } from "./types"
import { IUser } from "@/shared/api/users"

const initialState: UserDeleteRestoreState = {
    isModalOpen: false,
    currentUserId: null,
    mode: 'delete',
    onSuccess: null
}

interface OpenPayload {
    user: IUser
    mode: UserDeleteRestoreMode
    onSuccess?: () => void
}

const userDeleteRestoreSlice = createSlice({
    name: 'userDeleteRestore',
    initialState,
    reducers: {
        openUserDeleteRestoreModal: (state, action: PayloadAction<OpenPayload>) => {
            state.isModalOpen = true
            state.currentUserId = action.payload.user.id
            state.mode = action.payload.mode
            state.onSuccess = action.payload.onSuccess ?? null
        },
        closeUserDeleteRestoreModal: (state) => {
            state.isModalOpen = false
            state.currentUserId = null
            state.onSuccess = null
        },
    }
})

export default userDeleteRestoreSlice.reducer
export const { openUserDeleteRestoreModal, closeUserDeleteRestoreModal } = userDeleteRestoreSlice.actions
